const WORDS = ["Oats", "Nut butters", "Dates", "Honey", "Quality protein", "Fuel for rain or shine"];

export const Marquee = ({ dark = false }) => {
  const row = (aria) => (
    <div className="marquee-track flex shrink-0 items-center gap-10 pr-10" aria-hidden={aria}>
      {WORDS.map((w, i) => (
        <span key={w} className="flex items-center gap-10">
          <span className={`font-wide text-4xl sm:text-6xl lg:text-7xl uppercase whitespace-nowrap ${i % 2 ? "text-outline" : ""}`}>{w}</span>
          <svg viewBox="0 0 24 24" className="h-6 w-6 sm:h-9 sm:w-9 text-dano-red shrink-0" aria-hidden="true">
            <path d="M12 0 L14.5 9.5 L24 12 L14.5 14.5 L12 24 L9.5 14.5 L0 12 L9.5 9.5 Z" fill="currentColor" />
          </svg>
        </span>
      ))}
    </div>
  );
  return (
    <section
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y-2 py-6 sm:py-8 ${dark ? "bg-dano-ink text-dano-cream border-dano-ink" : "bg-dano-cream text-dano-ink border-dano-ink"}`}
    >
      <div className="marquee flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </section>
  );
};
